module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "splash"
  }, [_c('section', {
    staticClass: "body",
    style: (_vm.style)
  }, [_c('section', {
    staticClass: "shadow"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.siteCfg.title))]), _vm._v(" "), _c('nav', _vm._l((_vm.themeCfg.Splash), function(item) {
    return _c('only-link', {
      key: item.title,
      attrs: {
        "item": item
      }
    })
  }))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75aaf007","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Splash.vue
// module id = 158
// module chunks = 1